declare const KTComponents: any;
declare const KTMenu: any;

import { AfterViewInit, Component } from '@angular/core';
import { AuthService } from '../../api-services/AdminHRService/Login/auth.service';
import { Router } from '@angular/router';
import { PermissionService } from '../../api-services/Permission/permission.service';
import { StorageService } from '../../guards/StorageService';

@Component({
  selector: 'app-po-sidebar',
  standalone: false,
  templateUrl: './po-sidebar.component.html',
  styleUrl: './po-sidebar.component.css'
})
export class PoSidebarComponent  implements AfterViewInit {
  sidebarMenu: any = {};
  EmployeeName : any;
  DesignationName : any;
  profileUrl: string = '';

  constructor(
    private router: Router,
    public storageService: StorageService,
    private readonly permissionService: PermissionService,
    private readonly authService : AuthService
  ) { }

  ngOnInit(): void {
    this.permissionService.restore();
    this.sidebarMenu = this.permissionService.getSidebarStructure();
    this.EmployeeName = this.authService.getUser()?.employeeName;
    this.DesignationName = this.authService.getUser()?.designation;
    this.profileUrl = this.permissionService.getProfileUrl(this.router.url);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }

      if (typeof KTComponents !== 'undefined') {
        KTComponents.init();
      }
    }, 100);
  }

   btnSignOut() {
    this.authService.logout();
    this.permissionService.clear();
    this.storageService.clearAll();
    this.router.navigateByUrl('/SignIn');
  }

}
